import React from 'react';

import './CSHeader.scss'
import { Link } from 'react-router-dom';

function CaseStudyHeader({Pagetitle}) {

    return (

        <div className='header-container'>


            <div id='back-master-container'>

                <Link to="/" className="router-link">

                    <div className='back-container'>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon backarrow"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5 12l14 0" />
                            <path d="M5 12l4 4" />
                            <path d="M5 12l4 -4" />
                        </svg>

                        <p>Back</p>

                    </div>


                </Link>

                <p className='header-title'>{Pagetitle}</p>

            </div>

            <div className='header-link-container'>
                {/* <Link to="/" className="router-link"><p>Home</p></Link> */}
                <a href="/"> <p className='headerlinks'>Resume</p></a>
                <a href="/"> <p className='headerlinks'>Linkedin</p></a>

            </div>


        </div>

    )
}

export default CaseStudyHeader